import React from 'react'

export function ArrowDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path fill="#FFFFFF" d="M12 6.333l-4 4-4-4h8z" />
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M3.538 6.142A.5.5 0 014 5.833h8a.5.5 0 01.354.854l-4 4a.5.5 0 01-.708 0l-4-4a.5.5 0 01-.108-.545zm1.67.691L8 9.626l2.793-2.793H5.207z"
        clipRule="evenodd"
      />
    </svg>
  )
}
